// DEPLOY: /var/www/woody.wtf/frontend/src/chart/FibPanel.js
// Fib retracement settings for one fib drawing: each level can be shown/hidden, have its
// value changed, its own colour (blank = the drawing's colour) and shade the band up to
// the next shown level. Levels can be added and removed. Shading strength is the
// drawing's Fill slider. Desktop: panel beside the chart. Phone: slide-up sheet.
import React from 'react';
import { fibLevels } from './drawings';

const S = {
  panel:  { position: 'absolute', top: '80px', right: '72px', width: '290px', maxHeight: 'calc(100% - 116px)', overflowY: 'auto', zIndex: 17, background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', boxShadow: 'var(--shadow)', padding: '10px' },
  sheet:  { position: 'fixed', left: 0, right: 0, bottom: 0, maxHeight: '70vh', overflowY: 'auto', zIndex: 41, background: 'var(--surface)', borderRadius: '14px 14px 0 0', boxShadow: '0 -4px 24px rgba(0,0,0,0.15)', padding: '12px 14px 20px' },
  backdrop: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.25)', zIndex: 40 },
  head:   { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' },
  title:  { fontSize: '12px', fontWeight: 700, color: 'var(--text)', fontFamily: "'DM Mono',monospace", textTransform: 'uppercase', letterSpacing: '0.05em' },
  close:  { border: 'none', background: 'none', fontSize: '16px', color: 'var(--text-muted)', cursor: 'pointer' },
  cols:   { display: 'grid', gridTemplateColumns: '28px 1fr 40px 46px 26px', gap: '6px', alignItems: 'center', fontSize: '10px', color: 'var(--text-muted)', fontFamily: "'DM Mono',monospace", marginBottom: '4px' },
  row:    { display: 'grid', gridTemplateColumns: '28px 1fr 40px 46px 26px', gap: '6px', alignItems: 'center', padding: '3px 0', borderTop: '1px solid var(--border)' },
  num:    { width: '100%', padding: '4px 6px', fontSize: '13px', fontFamily: "'DM Mono',monospace", border: '1px solid var(--border)', borderRadius: '6px', background: 'var(--bg)', color: 'var(--text)', boxSizing: 'border-box' },
  colour: { width: '36px', height: '26px', padding: 0, border: '1px solid var(--border)', borderRadius: '6px', background: 'none', cursor: 'pointer' },
  x:      { border: 'none', background: 'none', color: 'var(--text-muted)', cursor: 'pointer', fontSize: '14px' },
  add:    { marginTop: '8px', width: '100%', padding: '7px', border: '1px dashed var(--border)', borderRadius: '6px', background: 'none', color: 'var(--accent)', cursor: 'pointer', fontSize: '12px' },
  check:  { width: '18px', height: '18px', accentColor: 'var(--accent)', margin: 0 },
};

export default function FibPanel({ drawing, mobile, onChange, onClose }) {
  if (!drawing) return null;
  const levels = fibLevels(drawing);
  const set = next => onChange({ fib: { ...(drawing.fib || {}), levels: next } });
  const edit = (i, patch) => set(levels.map((l, k) => (k === i ? { ...l, ...patch } : l)));

  const body = (
    <div style={mobile ? S.sheet : S.panel} onPointerDown={e => e.stopPropagation()}>
      <div style={S.head}>
        <span style={S.title}>Fib levels</span>
        <button style={S.close} onClick={onClose} title="Close">✕</button>
      </div>
      <div style={S.cols}><span>Show</span><span>Level</span><span>Colour</span><span>Shade ↓</span><span /></div>
      {levels.map((l, i) => (
        <div key={i} style={S.row}>
          <input type="checkbox" style={S.check} checked={l.on} onChange={e => edit(i, { on: e.target.checked })} />
          <input type="number" step="0.001" style={S.num} value={l.v}
                 onChange={e => { const v = parseFloat(e.target.value); if (!Number.isNaN(v)) edit(i, { v }); }} />
          <input type="color" style={S.colour} value={l.color || drawing.style.color}
                 onChange={e => edit(i, { color: e.target.value })} title="Level colour" />
          <input type="checkbox" style={S.check} checked={!!l.fill} onChange={e => edit(i, { fill: e.target.checked })}
                 title="Shade the band from this level to the next shown level" />
          <button style={S.x} title="Remove level" onClick={() => set(levels.filter((_, k) => k !== i))}>✕</button>
        </div>
      ))}
      <button style={S.add} onClick={() => set([...levels, { v: 1.618, on: true, color: null, fill: false }])}>+ Add level</button>
    </div>
  );
  return mobile ? <><div style={S.backdrop} onClick={onClose} />{body}</> : body;
}
